import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <AppSection />
        <RankingSection />
        <CardsSection />
        <IndexSection />
        <UpdatesSection />
        <CarouselSection />
        <CommentsSection />
        <ContactSection />
        <FeaturesSection />
        <AboutSection />
        <FaqSection />
        <TopicsSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}